import {
  CalculatedBalanceCollection,
  CalculatedBalancesArray,
  ScenarioBalanceParams,
} from "@bitwarden/web-vault/app/services/store/calculated-balance.collection.abstraction";
import { signal } from "@angular/core";

export class ScenarioBalanceByTransactionsCalculatedCollection extends CalculatedBalanceCollection {
  protected readonly type = "ScenarioBalanceByTransactions";
  protected calculations: CalculatedBalancesArray = [];

  protected _balances = signal<CalculatedBalancesArray>(null);
  readonly balances = this._balances.asReadonly();

  async updateCalculations(parameters: ScenarioBalanceParams): Promise<void> {
    const isStale = this.staleCheck();
    const promises: Promise<Record<string, number>>[] = [];
    for (const transactions of parameters.scenarioTransactions) {
      promises.push(this.getBalanceByTransactions(parameters.webWorkerQueue, transactions));
    }
    const results: Record<string, number>[] = await Promise.all(promises);
    if (isStale()) {
      return;
    }
    this.setBalances(results);
  }

  getCalculations(): CalculatedBalancesArray {
    return this.calculations;
  }

  private setBalances(balancesByTransactionsArray: Record<string, number>[]): void {
    this.calculations = [];
    for (const balancesByTransactions of balancesByTransactionsArray) {
      const balanceMap = new Map(Object.entries(balancesByTransactions));
      this.calculations.push(balanceMap);
    }
    this._balances.set(this.calculations);
  }

  protected clearCalculations(): void {
    this.calculations = [];
    this._balances.set(null);
  }

  triggerChanges(): void {}
}
